export default "__VITE_ASSET__DePkSmev__"